import React, { useEffect, useState } from "react";
import blogFetch from "../../../axios/config";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FormControl,
  TextField,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { getIdCompany } from "../../../utils/constantes";
import {
  IAddEquipment,
  IEquipment,
  IManufacturer,
} from "./equipmentInterfaces";
const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props: any, ref) => {
  const [equipment, setEquipment] = useState<IEquipment>({
    eqP_description: "",
    eqP_FK_companyId: getIdCompany(),
    eqP_PK_idEquipment: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [manufacturer, setManufacturer] = useState<IManufacturer[]>();

  useEffect(() => {
    getManufacturers();
    getEquipment();
  }, []);

  useImperativeHandle(ref, () => ({
    addEquipment,
    updateEquipment,
    deleteEquipment,
  }));

  const handleChangeManufacturer = (event: SelectChangeEvent<string>) => {
    const selectedManufacturer = manufacturer?.find(
      (item) =>
        item.mfC_PK_idManufacturer === Number.parseInt(event.target.value)
    );
    setEquipment({
      ...equipment,
      manufacturer: selectedManufacturer,
    });
  };

  const addEquipment = async () => {
    try {
      const addEquipment: IAddEquipment = {
        eqP_PK_idEquipment: 0,
        eqP_description: equipment.eqP_description,
        eqP_FK_companyId: equipment.eqP_FK_companyId,
        eqP_FK_ManufacturerId: equipment.manufacturer?.mfC_PK_idManufacturer,
      };

      const response = await blogFetch.post("/equipment", addEquipment);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getManufacturers = async () => {
    try {
      let response = await blogFetch.get("/manufacturer");
      let data = response.data;
      setManufacturer(data);
    } catch (error) {
      console.error(error);
    }
  };

  const updateEquipment = async () => {
    const updateEquipment: IAddEquipment = {
      eqP_description: equipment.eqP_description,
      eqP_FK_companyId: equipment.eqP_FK_companyId,
      eqP_PK_idEquipment: props.idEquipment,
      eqP_FK_ManufacturerId: equipment.manufacturer?.mfC_PK_idManufacturer,
    };

    try {
      const response = await blogFetch.put(
        "/equipment/" + props.idEquipment,
        updateEquipment
      );
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getEquipment = async () => {
    if (props.idEquipment != null) {
      try {
        setIsLoading(true);
        let response = await blogFetch.get(`/equipment/${props.idEquipment}`);
        let data = response.data;
        setEquipment(data);
        setIsLoading(false);
        return data;
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    }
  };

  const deleteEquipment = async () => {
    try {
      const response = await blogFetch.delete(
        "/equipment/" + props.idEquipment
      );
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          <center>
            <FontAwesomeIcon icon={faSpinner} spin />
          </center>
        </div>
      ) : (
        <div>
          <TextField
            required
            id="outlined-basic"
            label="Nome do Equipamento"
            variant="outlined"
            fullWidth
            className="mb-3"
            value={equipment.eqP_description}
            onChange={(e) =>
              setEquipment({ ...equipment, eqP_description: e.target.value })
            }
          />
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Fabricante</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={equipment.manufacturer?.mfC_name}
              label="Fabricante"
              sx={{ backgroundColor: "white" }}
              onChange={handleChangeManufacturer}
            >
              {manufacturer &&
                manufacturer.map((item) => (
                  <MenuItem
                    key={item.mfC_PK_idManufacturer}
                    value={item.mfC_PK_idManufacturer}
                  >
                    {item.mfC_name}
                  </MenuItem>
                ))}
              {equipment.manufacturer?.mfC_name && (
                <MenuItem
                  key={equipment.manufacturer?.mfC_PK_idManufacturer}
                  value={equipment.manufacturer?.mfC_name}
                >
                  {`${equipment.manufacturer?.mfC_name} `}
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </div>
      )}
    </>
  );
});
